/**
 * Turn an axios error into a message safe to render.
 *
 * FastAPI returns `detail` as a string for an HTTPException but as a LIST of
 * objects for 422 validation errors. Rendering that list directly throws
 * "Objects are not valid as a React child" and blanks the page — so the shape
 * has to be normalised wherever an error reaches the UI.
 */
export const apiError = (err, fallback = 'Something went wrong') => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((e) => (e?.loc ? `${e.loc[e.loc.length - 1]}: ${e.msg}` : e?.msg))
      .filter(Boolean);
    if (msgs.length) return msgs.join('; ');
  }
  return fallback;
};
